interface OcrBadgeIconProps {
  height: number;
  width: number;
}

export const OcrBadgeIcon = ({
  height = 16,
  width = 16,
}: OcrBadgeIconProps) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.7854 7.83594C8.09396 7.83594 8.34473 8.08603 8.34497 8.39453V8.4082C8.34497 8.7169 8.0941 8.9668 7.7854 8.9668H3.25513C2.94659 8.9666 2.69653 8.71678 2.69653 8.4082V8.39453C2.69677 8.08615 2.94674 7.83613 3.25513 7.83594H7.7854ZM8.9231 5.36035C9.2318 5.36035 9.48267 5.61024 9.48267 5.91895V5.93164C9.48267 6.24034 9.2318 6.49121 8.9231 6.49121H3.25513C2.94659 6.49102 2.69653 6.24022 2.69653 5.93164V5.91895C2.69653 5.61036 2.94659 5.36055 3.25513 5.36035H8.9231ZM8.98853 3.01367C9.26134 3.01369 9.48267 3.23499 9.48267 3.50781C9.48259 3.78057 9.26129 4.00194 8.98853 4.00195H3.19067C2.91789 4.00195 2.69661 3.78058 2.69653 3.50781C2.69653 3.23498 2.91785 3.01367 3.19067 3.01367H8.98853Z"
        fill="#736C64"
      />
      <path
        d="M7.7854 7.83594C8.09396 7.83594 8.34473 8.08603 8.34497 8.39453V8.4082C8.34497 8.7169 8.0941 8.9668 7.7854 8.9668H3.25513C2.94659 8.9666 2.69653 8.71678 2.69653 8.4082V8.39453C2.69677 8.08615 2.94674 7.83613 3.25513 7.83594H7.7854ZM8.9231 5.36035C9.2318 5.36035 9.48267 5.61024 9.48267 5.91895V5.93164C9.48267 6.24034 9.2318 6.49121 8.9231 6.49121H3.25513C2.94659 6.49102 2.69653 6.24022 2.69653 5.93164V5.91895C2.69653 5.61036 2.94659 5.36055 3.25513 5.36035H8.9231ZM8.98853 3.01367C9.26134 3.01369 9.48267 3.23499 9.48267 3.50781C9.48259 3.78057 9.26129 4.00194 8.98853 4.00195H3.19067C2.91789 4.00195 2.69661 3.78058 2.69653 3.50781C2.69653 3.23498 2.91785 3.01367 3.19067 3.01367H8.98853Z"
        stroke="#736C64"
      />
      <path
        d="M1 3.49023V1.84464C1 1.38432 1.37316 1.01116 1.83348 1.01116H3.54295"
        stroke="#736C64"
        strokeWidth="0.833482"
        strokeLinecap="round"
      />
      <path
        d="M1 8.51172V10.1573C1 10.6176 1.37316 10.9908 1.83348 10.9908H3.54295"
        stroke="#736C64"
        strokeWidth="0.833482"
        strokeLinecap="round"
      />
      <path
        d="M8.47668 1H10.1662C10.6265 1 10.9996 1.37316 10.9996 1.83348V3.49872"
        stroke="#736C64"
        strokeWidth="0.833482"
        strokeLinecap="round"
      />
      <path
        d="M8.47668 11H10.1662C10.6265 11 10.9996 10.6268 10.9996 10.1665V8.50128"
        stroke="#736C64"
        strokeWidth="0.833482"
        strokeLinecap="round"
      />
    </svg>
  );
};
